import { render, staticRenderFns } from "./TaskTypeName.vue?vue&type=template&id=034695c6&scoped=true&"
import script from "./TaskTypeName.vue?vue&type=script&lang=js&"
export * from "./TaskTypeName.vue?vue&type=script&lang=js&"
import style0 from "./TaskTypeName.vue?vue&type=style&index=0&id=034695c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034695c6",
  null
  
)

export default component.exports